// const COUNTRY_OPTIONS =

export const CONDITION_OPTIONS = [
  {
    label: 'Mint',
    value: 5,
  },
  {
    label: 'New',
    value: 4,
  },
  {
    label: 'Good',
    value: 3,
  },
  {
    label: 'Fair',
    value: 2,
  },
  {
    label: 'Damaged',
    value: 1,
  },
];
